<template>
	<div class="chat-messages">
		<div :is="messageStyle"
			v-for="(msg, index) in messages"
			@pasteText="$emit('pasteText', $event)"
			:message="msg"
			:key="index + '_' + msg.time"
			/>
	</div>
</template>

<script>
import eventBus from '../eventbus';
import MessageCompact from './messages/MessageCompact.vue';
import MessageCozy from './messages/MessageCozy.vue';

export default {
	components: {
		MessageCompact,
		MessageCozy,
	},

	data(){
		return {
			state: eventBus.state,
			messages: [],
		};
	},

	computed: {
		messageStyle(){
			return this.state.settings.messagesStyle == 'cozy' ? MessageCozy : MessageCompact;
		},
	},

	methods: {
		setMessages({room, messages}){
			this.messages = Object.clone(messages);
			this.$emit('reset');
		},

		addMessage({room, message}){
			this.messages.push(Object.clone(message));
			setTimeout(() => this.$emit('update'), 0);
		},
	},

	created(){
		// TODO: eventBus.$off someday

		eventBus.$on('setMessages', (data) => {
			this.setMessages(data);
		});

		eventBus.$on('addMessage', (data) => {
			this.addMessage(data);
		});
	},
}
</script>

<style lang="less">
@import (reference) "~@/css/chat.less";

.chat-msg {
	&:hover {
		background-color: rgba(255, 255, 255, 0.05);
	}

	.quote {
		display: block;
		background: url("/assets/i/quote.svg") no-repeat 0 4px ~"/" auto 9px;
		padding-left: 17px;
		margin-left: 10px;
		color: #ee8;
	}

	.code {
		display: inline-block;
		font-family: monospace, 'sans-serif-monospace', 'Roboto Mono', 'Consolas', 'Ubuntu Mono', 'Courier New';
		background-color: @color-chat-4;
		padding: 4px;
		border-radius: 2px;
		tab-size: 4;
	}
}

</style>

<style lang="less" scoped>
@import (reference) "~@/css/chat.less";
</style>
